import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { CookiesProvider } from "react-cookie";
import App, { NewCard, Village, Gallery, AllCard, Redirect, HowToUse, HowToUseAdvanced, HowToUseMpurse } from './App';
import { Permission } from './PermissionUI';
import { ItemDetail } from './ItemDetailUI';
import { Exhibit } from './ExhibitUI';
import { Note } from './NoteUI';
import { History } from './HistoryUI';
import { ManagementScreen } from './SettingUI';
import { NfcCallback } from './NativeAppUI';
// import reportWebVitals from './reportWebVitals';

const router = createBrowserRouter([
  {
    path: process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/' : '/',
    element: <App />,
    children: [
      { index: true, element: <NewCard /> },
      { path: 'index.html', element: <NewCard /> },
      { path: 'newcard', element: <NewCard /> },
      { path: 'plaza', element: <Village /> },
      { path: 'config', element: <ManagementScreen /> },
      { path: 'nfc-callback', element: <NfcCallback /> },
      { path: 'exhibit', element: <Exhibit /> },
      { path: 'home', element: <Gallery /> },
      { path: 'item', element: <ItemDetail /> },
      { path: 'allcard', element: <AllCard /> },
      { path: 'history', element: <History /> },
      { path: 'permission', element: <Permission /> },
      { path: 'note', element: <Note /> },
      { path: 'redirect', element: <Redirect /> },
      { path: 'howtouse', element: <HowToUse /> },
      { path: 'howtouseadvanced', element: <HowToUseAdvanced /> },
      { path: 'howtousempurse', element: <HowToUseMpurse /> },
    ]
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CookiesProvider>
      <RouterProvider router={router} />
    </CookiesProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
